import { all } from 'redux-saga/effects';
import fetchContracts from './fetchContracts';

export default function* () {
    yield all([fetchContracts()]);
}
